import React from "react";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import SweetAlert from "react-bootstrap-sweetalert";
import store from "../../store";
import { connect } from "react-redux";
import {
  alertDanger,
  alertWarning,
  successWarning,
  showSnack
} from "../../reducers/NotificationReducer";

import Snackbar from "components/Snackbar/Snackbar.jsx";

class NotificationWrapper extends React.Component {
  state = {
    errorDialogOpen: false
  };

  render() {
    return (
      <React.Fragment>
        {this.props.children}

        {/* -- ERROR ALERT -- */}

        {store.getState().alert.errorWindow.open ? (
          <SweetAlert
            danger
            title={store.getState().alert.errorWindow.title}
            onConfirm={() => {
              store.dispatch(
                alertDanger({ open: false, title: "", message: null })
              );
            }}
            confirmBtnCssClass={
              this.props.classes.button + " " + this.props.classes.info
            }
            confirmBtnText="Ok"
          >
            {store.getState().alert.errorWindow.message}
          </SweetAlert>
        ) : null}

        {/* --------------- */}

        {/* -- WARNING ALERT -- */}

        {store.getState().alert.warningWindow.open ? (
          <SweetAlert
            warning
            title={store.getState().alert.warningWindow.title}
            onConfirm={() => {
              store.dispatch(
                alertWarning({
                  confirmClicked: true,
                  open: false,
                  title: "",
                  message: null
                })
              );
            }}
            onCancel={() => {
              store.dispatch(
                alertWarning({
                  cancelClicked: true,
                  open: false,
                  title: "",
                  message: null
                })
              );
            }}
            confirmBtnCssClass={
              this.props.classes.button + " " + this.props.classes.success
            }
            cancelBtnCssClass={
              this.props.classes.button + " " + this.props.classes.danger
            }
            confirmBtnText={store.getState().alert.warningWindow.confirmBtnText}
            cancelBtnText={store.getState().alert.warningWindow.cancelBtnText}
            showCancel={store.getState().alert.warningWindow.showCancel}
            showConfirm={store.getState().alert.warningWindow.showConfirm}
          >
            {store.getState().alert.warningWindow.message}
          </SweetAlert>
        ) : null}

        {/* -- SUCCESS ALERT -- */}

        {store.getState().alert.successWindow.open ? (
          <SweetAlert
            success
            style={{
              display: "block",
              left: "60%",
              top: "25%",
              marginTop: "-0px"
            }}
            title={store.getState().alert.successWindow.title}
            onConfirm={() => {
              store.dispatch(
                successWarning({
                  confirmClicked: true,
                  open: false,
                  title: ""
                })
              );
            }}
            confirmBtnCssClass={
              this.props.classes.button + " " + this.props.classes.success
            }
          />
        ) : null}

        {/* --------------- */}

        <Snackbar
          place="br"
          color={store.getState().alert.snack.color}
          message={store.getState().alert.snack.message}
          open={store.getState().alert.snack.open}
          closeNotification={() => {
            store.dispatch(
              showSnack({
                open: false
              })
            );
          }}
          close
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  alert: state.alert
});

NotificationWrapper = connect(mapStateToProps)(NotificationWrapper);

export default withStyles(sweetAlertStyle)(NotificationWrapper);



// WEBPACK FOOTER //
// ./src/layouts/hoc/NotificationWrapper.jsx